// Demo content for "Five kinds of questions": one component per question type.
// Answers follow the mock screen's state; the assert lines are what a test would write.
import { HMI_STATE, pyFloat } from './screenData';

export const TASK_IDS = ['choose', 'check', 'read', 'read_number', 'choose_image'];

const TARGETS = {
    choose: 'header.status',
    check: 'overview.circulation_pump',
    read: 'overview.first_alarm',
    read_number: 'overview.pressure_value',
    choose_image: 'overview.pump_auto_mode',
};

const QUESTIONS = {
    choose: { zh: '图片中 STATUS 后面显示的运行状态是？', en: 'What run state is shown after STATUS?' },
    check: { zh: '图片中的状态是否显示 Off？', en: 'Does the status show Off?' },
    read: { zh: '图片中第一条报警的文字是什么？', en: 'What does the first alarm say?' },
    read_number: { zh: '图片中排气压力的读数是多少？', en: 'What is the discharge pressure reading?' },
    choose_image: { zh: '图片中的开关是哪种状态？', en: 'Which state is the switch in?' },
};

export function buildTask(id, lang, state) {
    const s = HMI_STATE[state];
    const base = { id, target: TARGETS[id], question: QUESTIONS[id][lang] };

    if (id === 'choose') {
        return { ...base, reply: s.status, assertLine: `assert r.answer == "${s.status}"` };
    }
    if (id === 'check') {
        const py = s.pump === 'Off' ? 'True' : 'False';
        return { ...base, reply: py, assertLine: `assert r.value is ${py}` };
    }
    if (id === 'read') {
        const text = s.alarm || 'No active alarms';
        return { ...base, reply: text, assertLine: `assert r.text == "${text}"` };
    }
    if (id === 'read_number') {
        return { ...base, reply: s.pressure, assertLine: `assert r.value == ${pyFloat(Number(s.pressure))}` };
    }
    // choose_image with pixels_first: the pixel comparison answers, the model is not asked.
    const answer = s.auto ? 'On' : 'Off';
    return {
        ...base,
        pixels: true,
        answer,
        refs: [
            { name: 'On', state: 'ready', distance: s.auto ? 1.6 : 47.9 },
            { name: 'Off', state: 'fault', distance: s.auto ? 47.9 : 1.6 },
        ],
        assertLine: `assert r.answer == "${answer}"`,
    };
}
